import { SecondarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import useForm from 'hooks/useForm'
import { PMSs } from 'main/hotelBrandsAndChains'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import styles from '../MultiStepPMSLogin.module.scss'
import ProcessConfirmationDialog from './processConfirmationDialog'

const ReviewAndFinalize = ({
  hubId,
  tenantId,
  propertyId,
  setIsOHIPConfigFinazized,
  setUpdateConfig
}) => {
  const pms = useSelector(s => s.login.subsidiaryPMS)

  const { addToast } = useToasts()
  const [showSuccessDialog, setShowSuccessDialog] = useState(false)
  const [showFailureDialog, setShowFailureDialog] = useState(false)
  const [testData, setTestData] = useState(null)

  const shouldFinalizeConfiguration = pms === PMSs.ohip

  const [formData, handleFormChange] = useForm({
    hubId: hubId,
    tenantId: tenantId,
    propertyId: propertyId,
    isConfirmed: false,
    step: 'Step5ReviewAndFinalize'
  })

  const handleTestOhipConnection = () => {
    pmsApi
      .testOhipConnection({ propertyId: propertyId })
      .then(res => {
        setTestData(res)
        addToast('Successful', {
          appearance: 'success',
          autoDismiss: true
        })
        setShowSuccessDialog(true)
      })
      .catch(() => {
        addToast(`Make sure the property id is correct and try again.`, {
          appearance: 'error',
          autoDismiss: true
        })
        setShowFailureDialog(true)
      })
  }

  const handleFormSubmission = isFinalize => {
    pmsApi
      .setOhipConfiguration(isFinalize ? { ...formData, isConfirmed: true } : formData)
      .then(() => {
        addToast('Successful', {
          appearance: 'success',
          autoDismiss: true
        })
        setIsOHIPConfigFinazized(true)
      })
      .catch(error => {
        addToast(`${error}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setShowSuccessDialog(false)
        setUpdateConfig(prev => prev + 1)
      })
  }

  const handleConfirm = () => {
    handleFormSubmission(true)
  }

  const handleClose = () => {
    if (showSuccessDialog) {
      handleFormSubmission(false)
    } else {
      setShowFailureDialog(false)
    }
  }

  return (
    <>
      {(showSuccessDialog || showFailureDialog) && (
        <ProcessConfirmationDialog
          success={showSuccessDialog}
          info={showSuccessDialog ? testData : null}
          handleSubmit={handleConfirm}
          handleClose={handleClose}
          shouldFinalizeConfiguration={shouldFinalizeConfiguration}
        />
      )}
      <div className={styles.stepActions}>
        <form className={styles.actionContainer}>
          <div className={styles.inputContainer}>
            <TextInput
              name="hubId"
              className={styles.textInput}
              type="string"
              label="Hub id"
              value={formData.hubId}
              onChange={handleFormChange}
              required
              disabled
            />
          </div>
          <div className={styles.inputContainer}>
            <TextInput
              name="propertyId"
              className={styles.textInput}
              type="string"
              label="Property id"
              value={formData.propertyId}
              onChange={handleFormChange}
              required
              disabled
            />
          </div>
          <div className={styles.inputContainer}>
            <SecondarySmallButton
              type="button"
              size="small"
              onClick={handleTestOhipConnection}
            >
              Test auth
            </SecondarySmallButton>
          </div>
        </form>
      </div>
    </>
  )
}

export default ReviewAndFinalize
